
import { toast } from "react-toastify";

function useResources() {
  const shareContent = async (data: {
    title?: string;
    text?: string;
    url: string;
  }) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: data.title,
          text: data.text,
          url: data.url,
        });
      } catch (error) { }
    } else {
      try {
        await navigator.clipboard.writeText(data.url);
        toast.success("URL copied to clipboard");
      } catch (error) {
        // console.error('Clipboard copy failed:', error);
      }
    }
  };



  return {
    shareContent
  };
}

export default useResources;
